
















































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { STATUS } from '@front-app/constants/state';
import { useIsError, useIsLoading } from '@front-app/hooks/useAsyncStatus';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '../cards/state/ErrorCard.vue';

export default defineComponent({
	components: {
		CtaButton,
		FontAwesomeIcon,
		ErrorCard,
	},
	props: {
		numSteps: {
			type: Number,
			required: true,
		},
		currentStep: {
			type: Number,
			required: true,
		},
		status: {
			type: String as PropType<STATUS>,
			default: STATUS.UNSTARTED,
		},
	},
	setup(props) {
		const isFinalStep = computed(() => (props.currentStep >= (props.numSteps - 1)));
		const finalButtonPalette = computed(() => (isFinalStep.value ? ButtonPalettes.SUCCESS : ButtonPalettes.PRIMARY));
		const isLoading = useIsLoading(computed(() => props.status));
		const isError = useIsError(computed(() => props.status));
		return {
			isLoading,
			isError,
			isFinalStep,
			finalButtonPalette,
		};
	},
});
